import React, { useMemo } from "react";
import { Layout, Menu } from "antd";
import {
    DashboardOutlined,
    CalendarOutlined,
    FileTextOutlined,
    BarChartOutlined,
    ClockCircleOutlined,
    CreditCardOutlined,
    SafetyCertificateOutlined,
    UserOutlined,
    LogoutOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Sider } = Layout;

export default function PatientSidebar({ collapsed, onCollapse }) {
    const navigate = useNavigate();
    const location = useLocation();

    const menuItems = useMemo(
        () => [
            { key: "/patient-dashboard", icon: <DashboardOutlined />, label: "Dashboard" },
            { key: "/my-appointments", icon: <CalendarOutlined />, label: "Appointment Manag." },
            { key: "/prescriptions", icon: <FileTextOutlined />, label: "Prescriptions" },
            { key: "/reports", icon: <BarChartOutlined />, label: "Reports" },
            { key: "/medical-history", icon: <ClockCircleOutlined />, label: "Medical History" },
            { key: "/billing", icon: <CreditCardOutlined />, label: "Billing" },
            { key: "/insurance-support", icon: <SafetyCertificateOutlined />, label: "Insurance Support" },
            { key: "/profile", icon: <UserOutlined />, label: "Profile" },
            { key: "/logout", icon: <LogoutOutlined />, label: "Logout", danger: true },
        ],
        []
    );

    const handleMenuClick = ({ key }) => {
        if (key === "/logout") {
            sessionStorage.clear();
            localStorage.clear();
            navigate("/");
            return;
        }
        navigate(key);
    };

    return (
        <Sider
            width={260}
            collapsible
            collapsed={collapsed}
            onCollapse={onCollapse}
            theme="light"
            className="border-end"
            breakpoint="lg"
        >
            <div className="px-4 py-7 border-bottom">
                <div className="fs-1 fw-bolder text-dark">Logo</div>
                {!collapsed && <div className="text-muted fs-7 mt-1">Patient Portal</div>}
            </div>

            <div className="p-3">
                <Menu
                    mode="inline"
                    selectedKeys={[location.pathname]}
                    items={menuItems}
                    onClick={handleMenuClick}
                    style={{ borderInlineEnd: 0 }}
                />
            </div>
        </Sider>
    );
}
